module.exports = {
	"signModal": {
		"saved": {
			"title": "Your saved { type, select, S {signatures} I {initials} }",
			"header": {
				"text": "Your Saved Signatures"
			},
			"tip": {
				"label": "Tip",
				"text": "If you save another { type, select, S {signature} I {set of initials} }, you will be able to access it here."
			},
			"delete": {
				"linkText": "delete",
				"confirmMessage": {
					"S": "Are you sure you want to delete this signature?\nYou will not be able to access it in the future.",
					"I": "Are you sure you want to delete these initials?\nYou will not be able to access it in the future."
				}
			},
			"empty": {
				"text": "You do not have any saved { type, select, S {signatures} I {initials} }",
				"subText": "Please select an option from the left to create your { type, select, S {signature} I {initials} }."
			}
		},
		"drawn": {
			"title": "CREATE {type, select, S {SIGNATURE} I {INITIALS}}",
			"clear": {
				"linkText": "Clear"
			},
			"tip": {
				"labelText": "Rotate to have more room"
			},
			"error": {
				"signature_too_small": "Please make your { type, select, S {signature} I {initials} } larger. It doesn't meet the minimum size requirement.",
				"no_signature": "Please draw your { type, select, S {signature} I {initials} } using your finger."
			}
		},
		"typed": {
			"title": "CREATE {type, select, S {SIGNATURE} I {INITIALS}}",
			"changeFonts": {
				"linkText": "Change font"
			},
			"error": {
				"S": "You must type your signature",
				"I": "You must type your initials"
			},
			"placeholder": {
				"S": "Your name",
				"I": "Your initials"
			}
		},
		"upload": {
			"title": "CREATE {type, select, S {SIGNATURE} I {INITIALS}}",
			"button": {
				"text": "UPLOAD"
			},
			"instructions": {
				"header": "Upload a picture of your {type, select, S {signature} I {initials}}",
				"fileSize": "Maximum file size: 40 MB",
				"fileFormats": "Acceptable file formats: png, jpg, jpeg, bmp, gif"
			},
			"error": {
				"fileType": "Invalid file type '{fileType}' supplied.",
				"fileSize": "File is too large ({fileSize})!"
			}
		},
		"email": {
			"title": "CREATE {type, select, S {SIGNATURE} I {INITIALS}}",
			"instructions": {
				"header": "Please follow the instructions below:",
				"step_1": "1. Take a photo of your {type, select, S {signature} I {initials}}.",
				"step_2": "2. Email the photo to:",
				"subject": "    With a subject of:",
				"step_3": "3. Click 'Continue'"
			}
		},
		"error": {
			"title": "ERROR",
			"header": "Sorry!",
			"body": "Something went wrong. Please try again.",
			"unknown": "An unexpected error occurred. Please contact support@hellosign.com."
		},
		"actions": {
			"back": {
				"linkText": "back"
			},
			"insert": {
				"linkText": "Insert { everywhere, select, 0 {} 1 {everywhere} }"
			},
			"legal": {
				"labelText": "I understand this is a legal representation of my { type, select, S {signature} I {initials} }."
			},
			"continue": {
				"labelText": "Continue"
			}
		},
		"signatureEditArea": {
			"instructions": "To crop your {type, select, S {signature} I {initials}}, click and drag to create a bounding box.",
			"controls": {
				"contrast": {
					"labelText": "Adjust Contrast"
				},
				"rotate": {
					"labelText": "Rotate {type, select, S {signature} I {initials}}"
				}
			}
		},
		"menu": {
			"labelText": "{ tabId, select, SS {Saved signatures} SI {Saved initials} C {Draw it in} T {Type it in} U {Upload image} E {Use smartphone} }"
		},
		"loader": {
			"text": "Saving your { type, select, S {signature} I {initials} }"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/translations/en-US.json
 ** module id = 663
 ** module chunks = 0
 **/